import { render, staticRenderFns } from "./ReminderModal.vue?vue&type=template&id=a72f26e8&scoped=true&lang=pug&"
import script from "./ReminderModal.vue?vue&type=script&lang=js&"
export * from "./ReminderModal.vue?vue&type=script&lang=js&"
import style0 from "./ReminderModal.vue?vue&type=style&index=0&id=a72f26e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72f26e8",
  null
  
)

export default component.exports